import { createStore } from 'redux-dynamic-modules';
import { getThunkExtension } from 'redux-dynamic-modules-thunk';
import getPaymentModule from './payment/paymentReducer';

export const getStore = () =>
  createStore(
    {
      extensions: [getThunkExtension()],
    },
    getPaymentModule(),
  );

const store = getStore();

export type RootState = ReturnType<typeof store.getState>;
export default store;
